/* istanbul ignore file */
import axios from 'axios';
import { config } from '../config/index'

const instance = axios.create({
  baseURL: config.api
});

export default instance;
